import { colors } from '@giphy/react-giphy-brand'
import { PureComponent } from 'react'
import { withRouter } from 'react-router'
import { Content, CTAButton as BrandCTAButton, FormContainer } from 'shared/components/form/form-components'
import styled from 'styled-components'
import { TermsOfServiceLogin, ForgotPassword } from 'shared/components/form/copy'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import FacebookButton from 'shared/components/form/facebook-button'
import AppleButton from 'shared/components/form/apple-button'
import appendNextUrl from 'shared/components/form/get-next-url'
import LoginFields, { FIELDS } from 'shared/components/form/fields'

const sectionMargin = 6

const FacebookButtonWithMargin = styled(FacebookButton)`
    margin-bottom: ${sectionMargin}px;
`

const AppleButtonWithMargin = styled(AppleButton)`
    margin-bottom: ${sectionMargin}px;
`

const FormContent = styled(Content)`
    width: ${props => props.width}px;
`

const CTAButton = styled(BrandCTAButton)`
    width: 100%;
    background: linear-gradient(-135deg, #6157ff 0%, #9933ff 100%);
    opacity: ${props => (props.disabled ? '60' : '100')}% !important;
    font-size: 15px;
    border-radius: 3px;
    cursor: pointer;
`

@CSRFToken
@withRouter
class Form extends PureComponent {
    state = {
        submitEnabled: false,
    }
    areFieldsOkay = () => this.isFormValid
    onValidChange = isFormValid => {
        this.isFormValid = isFormValid
        this.setState({ submitEnabled: this.areFieldsOkay() })
    }
    submit = event => {
        event.stopPropagation()
        event.preventDefault()
        if (this.areFieldsOkay()) {
            this.form.submit()
        }
    }
    render() {
        const { submitEnabled } = this.state
        const { csrftoken, width } = this.props
        return (
            <FormContainer>
                <form method="POST" action={appendNextUrl(`/login`)} onSubmit={this.submit} ref={c => (this.form = c)}>
                    {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                    <FormContent width={width}>
                        <LoginFields
                            onValidChange={this.onValidChange}
                            showFields={[FIELDS.email, FIELDS.password]}
                            borderRadius={3}
                        />
                        <CTAButton
                            color={submitEnabled ? colors.primaryCTA : colors.giphyDarkGrey}
                            disabled={!submitEnabled}
                        >
                            Log in
                        </CTAButton>
                        <ForgotPassword />
                        <FacebookButtonWithMargin
                            label="Log In with Facebook"
                            onClick={() => (location.href = `/login/facebook/${location.search}`)}
                        />
                        <AppleButtonWithMargin
                            label="Log In with Apple"
                            onClick={() => (location.href = `/login/apple/${location.search}`)}
                        />
                        <TermsOfServiceLogin />
                    </FormContent>
                </form>
            </FormContainer>
        )
    }
}

export default Form
